import React from 'react';
import isEqual from 'lodash/isEqual';
import { Helmet } from 'react-helmet-async';
import { Redirect } from 'react-router-dom';
import { ComponentMapping, Page } from '@adobe/aem-react-editable-components';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
class BaseDetailsPage extends Page {
    constructor(props) {
        super(props);
        this.state = {
            event: DigitalDataMutation.CP_VIEW,
            key: '',
            analyticsData: {},
            componentMapping: ComponentMapping,
        };
    }
    get containerProps() {
        const attrs = super.containerProps;
        attrs.className = `${attrs.className || ''} page ${this.props.cssClassNames || ''}`;
        return attrs;
    }
    setPageProperties = () => {
        const { isRightToLeft, isInAuthor, currentCountryRoot, currentLanguageRoot, commercetoolsProjectKey, setPageProperties, language, labels = {}, ecommerceEnabled, languageRootPath, cqType, externalCart, pageLevelNavigation, locale, brandSlug, categoryTitle, title, is70thLogoEnabled, isoCountryCode, locationMismatchModalModel, isShowDriverLicenseEnabled, daysToShowNew, isNewsletterSubscriptionEnabled, cqPath, globalSearchItemId, bloomreachModel, searchResultsPageUrl, dealerLocatorPageUrl, isSearchEnabled, isNavLoggedInIndicatorEnabled, } = this.props;
        setPageProperties({
            isRightToLeft,
            isInAuthor,
            currentCountryRoot,
            currentLanguageRoot,
            commercetoolsProjectKey,
            language,
            labels,
            ecommerceEnabled,
            languageRootPath,
            pageType: cqType,
            externalCart,
            pageLevelNavigation,
            locale,
            brandSlug,
            categoryTitle,
            title,
            isoCountryCode,
            locationMismatchModalModel,
            isShowDriverLicenseEnabled,
            daysToShowNew,
            isNewsletterSubscriptionEnabled,
            cqPath,
            globalSearchItemId,
            bloomreachModel,
            searchResultsPageUrl,
            is70thLogoEnabled,
            dealerLocatorPageUrl,
            isSearchEnabled,
            isNavLoggedInIndicatorEnabled,
        });
    };
    setAnalyticsData(event, data, key) {
        if (data && event && key) {
            setDigitalData(DigitalDataMutation.CP_VIEW, this.props.webData);
            setDigitalData(event, {
                ...this.props.webData,
                data,
            });
            this.setState({
                event,
                key,
                analyticsData: data,
            });
        }
        else {
            setDigitalData(DigitalDataMutation.CP_VIEW, this.props.webData);
            this.setState({
                analyticsData: this.props.webData,
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.webData, this.props.webData)) {
            this.setAnalyticsData(this.state.event, this.state.analyticsData, this.state.key);
        }
    }
    componentDidMount() {
        this.setPageProperties();
        if (this.props.destinationEntityId) {
            this.fetchDetailsData();
        }
    }
    componentWillUnmount() {
        this.setInitialData();
    }
    render() {
        return (React.createElement(React.Fragment, null,
            this.props.redirectTargetUrl && React.createElement(Redirect, { to: this.props.redirectTargetUrl }),
            React.createElement(Helmet, null,
                React.createElement("link", { rel: "canonical", href: this.props?.canonical, "data-react-helmet": "true" }),
                React.createElement("meta", { name: "template", content: this.props?.templateName, "data-react-helmet": "true" })),
            this.childComponents,
            this.childPages));
    }
}
export default BaseDetailsPage;
